import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "kpi-card" }
const _hoisted_2 = { class: "kpi" }
const _hoisted_3 = { class: "kpi__label" }
const _hoisted_4 = { class: "kpi__value" }
const _hoisted_5 = { class: "kpi" }
const _hoisted_6 = { class: "kpi__label" }
const _hoisted_7 = { class: "kpi__value" }
const _hoisted_8 = {
  key: 0,
  class: "kpi"
}
const _hoisted_9 = { class: "kpi__label" }
const _hoisted_10 = { class: "kpi__value" }
const _hoisted_11 = { class: "kpi-period-filter" }
const _hoisted_12 = {
  key: 0,
  class: "period-text"
}
const _hoisted_13 = {
  key: 1,
  class: "period-text"
}
const _hoisted_14 = {
  key: 3,
  class: "period-plus"
}
const _hoisted_15 = { class: "period-popover-content" }
const _hoisted_16 = { class: "period-field" }
const _hoisted_17 = ["max"]
const _hoisted_18 = { class: "period-field" }
const _hoisted_19 = ["min"]
const _hoisted_20 = { class: "period-popover-actions" }
const _hoisted_21 = ["disabled"]

import { ref, computed, onMounted, onUnmounted } from "vue";
import dayjs from "dayjs";


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanningKpiCard',
  props: {
    weekNumber: {},
    weekTotal: {},
    weekExpected: {},
    monthLabel: {},
    monthTotal: {},
    monthExpected: {},
    periodStart: {},
    periodEnd: {},
    periodTotal: {},
    periodExpected: {}
  },
  emits: ["update:period"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showPopover = ref(false);
const localStart = ref<string>("");
const localEnd = ref<string>("");
const buttonRef = ref<HTMLElement | null>(null);
const popoverRef = ref<HTMLElement | null>(null);

const weekLabel = computed(() => `Week ${props.weekNumber}`);

const hasCustomPeriod = computed(() => {
  return props.periodStart !== null && props.periodEnd !== null;
});

const weekDiff = computed(() => props.weekTotal - props.weekExpected);
const monthDiff = computed(() => props.monthTotal - props.monthExpected);
const periodDiff = computed(() => props.periodTotal - props.periodExpected);

const weekDiffClass = computed(() => {
  if (weekDiff.value >= 0) return "diff-positive";
  return "diff-negative";
});

const monthDiffClass = computed(() => {
  if (monthDiff.value >= 0) return "diff-positive";
  return "diff-negative";
});

const periodDiffClass = computed(() => {
  if (periodDiff.value >= 0) return "diff-positive";
  return "diff-negative";
});

const weekDiffIcon = computed(() => {
  return weekDiff.value >= 0 ? "▲" : "▼";
});

const monthDiffIcon = computed(() => {
  return monthDiff.value >= 0 ? "▲" : "▼";
});

const periodDiffIcon = computed(() => {
  return periodDiff.value >= 0 ? "▲" : "▼";
});

const periodLabel = computed(() => {
  if (!props.periodStart || !props.periodEnd) return "";
  return `${formatDate(props.periodStart)} - ${formatDate(props.periodEnd)}`;
});

const formatDate = (date: string | null): string => {
  if (!date) return "";
  return dayjs(date).format("DD/MM");
};

const formatMinutesAsTime = (minutes: number) => {
  const safeMinutes = Math.max(Math.round(Math.abs(minutes)), 0);
  const hours = Math.floor(safeMinutes / 60);
  const remainingMinutes = safeMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(remainingMinutes).padStart(
    2,
    "0",
  )}`;
};

const togglePopover = () => {
  showPopover.value = !showPopover.value;
  if (showPopover.value) {
    localStart.value = props.periodStart ?? "";
    localEnd.value = props.periodEnd ?? "";
  }
};

const closePopover = () => {
  showPopover.value = false;
};

const applyPeriod = () => {
  if (localStart.value && localEnd.value) {
    emit("update:period", localStart.value, localEnd.value);
    closePopover();
  }
};

const clearPeriod = () => {
  emit("update:period", null, null);
};

const handleClickOutside = (event: MouseEvent) => {
  if (!showPopover.value) return;

  const target = event.target as Node;
  if (buttonRef.value?.contains(target) || popoverRef.value?.contains(target)) {
    return;
  }

  closePopover();
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(weekLabel.value), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(formatMinutesAsTime(__props.weekTotal)), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["kpi__diff", weekDiffClass.value])
      }, _toDisplayString(weekDiffIcon.value) + " " + _toDisplayString(formatMinutesAsTime(Math.abs(weekDiff.value))), 3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(__props.monthLabel), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(formatMinutesAsTime(__props.monthTotal)), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["kpi__diff", monthDiffClass.value])
      }, _toDisplayString(monthDiffIcon.value) + " " + _toDisplayString(formatMinutesAsTime(Math.abs(monthDiff.value))), 3)
    ]),
    (hasCustomPeriod.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(periodLabel.value), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(formatMinutesAsTime(__props.periodTotal)), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["kpi__diff", periodDiffClass.value])
          }, _toDisplayString(periodDiffIcon.value) + " " + _toDisplayString(formatMinutesAsTime(Math.abs(periodDiff.value))), 3)
        ]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "kpi-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: _normalizeClass(["period-filter-btn", { 'period-filter-btn--active': hasCustomPeriod.value }]),
        onClick: togglePopover,
        ref_key: "buttonRef",
        ref: buttonRef
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "period-icon" }, "📅", -1)),
        (hasCustomPeriod.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Du " + _toDisplayString(formatDate(__props.periodStart)) + " au " + _toDisplayString(formatDate(__props.periodEnd)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, "Filtrer une période")),
        (hasCustomPeriod.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "period-clear",
              onClick: _withModifiers(clearPeriod, ["stop"])
            }, "✕"))
          : (_openBlock(), _createElementBlock("span", _hoisted_14, "➕"))
      ], 2),
      (showPopover.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "period-popover",
            ref_key: "popoverRef",
            ref: popoverRef
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "period-popover-header" }, [
              _createElementVNode("span", null, "Sélectionner une période")
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Date de début", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localStart).value = $event)),
                  max: localEnd.value || undefined
                }, null, 8, _hoisted_17), [
                  [_vModelText, localStart.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "Date de fin", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localEnd).value = $event)),
                  min: localStart.value || undefined
                }, null, 8, _hoisted_19), [
                  [_vModelText, localEnd.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "period-popover-btn period-popover-btn--cancel",
                onClick: closePopover
              }, " Annuler "),
              _createElementVNode("button", {
                class: "period-popover-btn period-popover-btn--apply",
                disabled: !localStart.value || !localEnd.value,
                onClick: applyPeriod
              }, " Appliquer ", 8, _hoisted_21)
            ])
          ], 512))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})